<template>
    <div class="columns">
        <slot/>
    </div>
</template>
